// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { TrackerConfig, ITrackerConfig } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getTrackerConfigEntity(id?: string): ApiResult<TrackerConfig> {
	return get<ITrackerConfig>(`/api/trackerconfig/${ id }`).then(result => result === undefined ? undefined :  new TrackerConfig(result));
}

export async function getAll(): ApiResult<TrackerConfig[]> {
	return get<ITrackerConfig[]>(`/api/trackerconfig`).then(result => result === undefined ? undefined : result.map(o => new TrackerConfig(o)));
}

export async function save(trackerConfig: TrackerConfig): ApiResult<TrackerConfig> {
	return post<ITrackerConfig>(`/api/trackerconfig`, trackerConfig).then(result => result === undefined ? undefined :  new TrackerConfig(result));
}

export async function deleteConfig(id?: string): ApiResult<undefined> {
	return del(`/api/trackerconfig/${ id }`);
}

export async function forceDeleteConfig(id?: string): ApiResult<undefined> {
	return post(`/api/trackerconfig/${ id }/force-delete`);
}
